import React, { Fragment } from 'react';
import { util } from 'veritone-redux-common';
import { map, findLast, includes, trimEnd } from 'lodash';
import { connect } from 'react-redux';
import { selectUser } from 'modules/user';

import {
  fetchDataSchema,
  getDataSchemas,
  getFailedFetchingDataSchemas,
} from 'modules/data-schema';

import { PropTypes, injectInto } from 'helpers/react';

import { Container, Row, Col } from 'shared-components/grid';
import rootSaga from '../modules/details-sagas';
import { Tabs, Tab } from 'shared-components/Tabs';
import withData from 'shared-components/withData';
import FailureScreen from 'shared-components/FailureScreen';
import AppBar from 'shared-components/AppBar';
import FullScreenDialog from 'shared-components/FullScreenDialog';

import styles from './styles/details.scss';

const {
  children,
  string,
  shape,
  routerShape,
  arrayOf,
  object,
  number
} = PropTypes;
const saga = util.reactReduxSaga.saga;

@withData([
  {
    action: ownProps => fetchDataSchema(ownProps.params.dataSchemaId),
    blockPageLoad: true
  }
])
@connect((state, ownProps) => ({
  userOrg: selectUser(state).organization.organizationId,
  registrySchemaData: getDataSchemas(state)[ownProps.params.dataSchemaId],
  error: getFailedFetchingDataSchemas(state).includes(
    ownProps.params.dataSchemaId
  )
    ? 'Data Schema failed to load.'
    : null
}))
@saga(rootSaga)
export default class DataSchemaDetailsContainer extends React.Component {
  static propTypes = {
    params: shape({ dataSchemaId: string }).isRequired,
    registrySchemaData: shape({
      id: string,
      name: string,
      description: string,
      organizationId: string,
      schemas: shape({
        count: number,
        records: arrayOf(object)
      })
    }).isRequired,
    error: string,
    children,
    router: routerShape,
    route: shape({
      childRoutes: arrayOf(shape({ path: string }))
    }),
    userOrg: number.isRequired
  };

  static defaultProps = {
    actions: []
  };

  // TODO: implement panel
  // state = {
  //   showInfoPanel: false
  // };

  handlePageChange = (event, value) => {
    this.props.router.push(
      `/data-schemas/${this.props.router.params.dataSchemaId}/${value}`
    );
  };

  handleClose = () => {
    this.props.router.push('/data-schemas/overview');
  };

  readMode = () => {
    this.props.router.push(
      trimEnd(this.props.router.location.pathname, '/edit')
    );
  };

  editMode = () => {
    this.props.router.push(`${this.props.router.location.pathname}/edit`);
  };

  // toggleInfoPanel = () => {
  //   return this.setState({ showInfoPanel: !this.state.showInfoPanel });
  // };

  render() {
    const { router } = this.props;
    const childRoutes = map(this.props.route.childRoutes, 'path');
    const path = router.location.pathname.split('/');
    const activePage = findLast(path, pathname =>
      childRoutes.includes(pathname)
    );
    const isEditing = includes(router.location.pathname, '/edit');
    const { schemaId } = this.props.router.params;
    let indexNumber = 0;
    this.props.registrySchemaData.schemas.records.forEach((item, index) => {
      if (item.id === schemaId) {
        indexNumber = index;
        return;
      }
    });
    return (
      <Fragment>
        {this.props.error &&
          <Container topBarOffset sideBarOffset>
            <Row>
              <Col>
                <FailureScreen message={this.props.error} />
              </Col>
            </Row>
          </Container>}
        <FullScreenDialog open={!this.props.error}>
          <AppBar
            title={this.props.registrySchemaData.name}
            closeButton
            onClose={this.handleClose}
          />
          <div style={{ overflowY: 'scroll', height: '100%' }}>
            <Container
              appBarOffset
              className={styles['schema-details-container']}
            >
              {!isEditing &&
                <div className={styles['schema-details-header']}>
                  <Col lg={4} style={{ marginLeft: 0, marginBottom: 0 }}>
                    <Tabs value={activePage} onChange={this.handlePageChange}>
                      <Tab
                        label="Schema"
                        value="schema"
                        className={styles['tabItem']}
                      />
                      <Tab
                        label="Configuration"
                        value="configuration"
                        className={styles['tabItem']}
                      />
                    </Tabs>
                  </Col>
                  <hr style={{ marginTop: 0 }} />
                </div>}
              {injectInto(this.props.children, {
                router: router,
                registrySchemaData: this.props.registrySchemaData,
                selectedSchemaIndex: indexNumber,
                readMode: this.readMode,
                editMode: this.editMode,
                isUserOrgSchema:
                  this.props.userOrg ===
                  parseInt(this.props.registrySchemaData.organizationId),
                isEditing
                // showInfoPanel: this.state.showInfoPanel
              })}
            </Container>
          </div>
        </FullScreenDialog>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/structured-data/components/DataSchemaDetailsContainer.js